import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { HttpClient, provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideNativeDateAdapter } from '@angular/material/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { routes } from './app.routes';
import { MatIconModule } from '@angular/material/icon';
import { importProvidersFrom } from '@angular/core';

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

import {
  AlertasService,
  CargandoService,
  FileDownloadService,
  GenericService,
  VariableLocalSesionService,
} from 'new-sysman-ui';
import { globalLoadingInterceptor } from './core/interceptors/global-loading.functional.interceptor';
import { guardarGrupoUsuarioInterceptor } from './core/interceptors/guardar-grupo-usuario.interceptor';
import { RobustFileDownloadService } from './core/services/file-download.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptors([globalLoadingInterceptor, guardarGrupoUsuarioInterceptor])),
    provideNativeDateAdapter(),
    importProvidersFrom(MatIconModule),
    // Configuración de ngx-translate
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }).providers!,
    AlertasService,
    CargandoService,
    GenericService,
    VariableLocalSesionService,
    // Reemplaza la descarga de la librería por una implementación robusta y
    // compatible con todos los navegadores (Chrome, Firefox, Edge, Safari).
    { provide: FileDownloadService, useClass: RobustFileDownloadService },
  ],
};
